/* eslint-disable max-lines */
/**
 * Stand Worksheet service
 */
import { Injectable, Injector } from '@angular/core';

import { BaseService } from '../base';
import {
  CELL_FILTER,
  CELL_RENDERER,
  COLUMN_SELECTOR_ID,
  EBasePriceTypes,
  EHeaderName,
  ENTITY_TYPES,
  EntityId,
  IApiListResponse,
  IBaseEntityResponse,
  IBaseEntityType,
  IDocumentOperationOptions,
  IEntityConfig,
  IEvent,
  IFilterQuery,
  IModalDialogOptions,
  IModalDialogResult,
  IProcessedEvent,
  IProduct,
  IProductMap,
  IProductPrice,
  IRecipeVenue,
  ISiteResponse,
  NotificationType,
  ObjectId,
  SiteForTransfer,
  STAND_WORKSHEET_GLOBAL_PRICE_SETTING,
  ISite,
  IQuantityOnHandResponse,
  IQuantityOnHandItem,
  IQohInventoryItemVenue,
  EPRODUCT_TYPES,
  IStandWorkSheetItemItemViewAuditLog,
  IAuditTrailFormRule,
  IEntityFilterItem,
  IAuditTrailData,
  IStandWorkSheetItemUpdatedFieldsMap,
  IStandWorkSheetItemViewAuditLog,
  IAuditLog,
  IAuditLogItem,
  ISWItemViewAudit,
  EAUDIT_LOG_OPERATION,
  FilterItemsSourceEnum,
} from '@shared/types';
import { BehaviorSubject, forkJoin, Observable, of, iif, Subject } from 'rxjs';
import { lazyInject } from '@containers/base/decorators';
import { EventsActions, UiActions, XprtDataActions } from '@store/actions';
import {
  chain,
  compact,
  concat,
  filter,
  find,
  first,
  flatten,
  flow,
  forEach,
  get,
  has,
  head,
  includes,
  isEmpty,
  isEqual,
  isNil,
  last,
  lowerCase,
  map,
  maxBy,
  merge,
  omit,
  reduce,
  set,
  sortBy,
  split,
  toLower,
  uniq,
  xorWith,
  isUndefined,
  unset,
  pick,
  isNull,
  every,
  nth,
} from 'lodash';
import { XprtDataService } from '../xprt-data';
import { DmDataService } from '../dm-data';
import {
  observableCombineLatest,
  observableOf,
  observableThrowError,
  rx,
} from '@shared/rx';
import { XUXListContainerComponent } from '@containers/base';
import { detectMobile } from '@geniuspos/ui-shared/modules/xdm-shared-components/components/utils';
import { NgRedux, select } from '@angular-redux/store';
import { IAppState } from '@app/store';
import { STATE_SELECTORS } from '@shared/services/state-service';
import { standWorkSheetModalDefinition } from '@shared/services/stand-worksheet/modal.definition';
import {
  ICellRendererParams,
  ValueFormatterParams,
  ValueGetterParams,
} from 'ag-grid-community';
import { InventoryItemVenueService } from '../inventory-item-venue';
import { RecipeVenueService } from '../recipe-venue';
import { HttpParams } from '@angular/common/http';
import {
  IInformationData,
  ISitesForStandWorkSheet,
  IStandSheet,
  IStandSheetCombineData,
  IStandWorkSheetItem,
  IStandWorkSheetItemFullData,
  IStandWorkSheetItemToEnd,
  ChangedStandSheetItems,
  IBulkPrintData,
  IAllBulkPrintData,
} from '@app/shared/types/entities/stand-worksheet';
import {
  FilterOptionType,
  ISiteTag,
  ToolbarButtonDefinition,
} from '@geniuspos/ui-shared';
import { EVENT_STATUS_VALUE } from '@shared/types/enums/event-status.enum';
import { ProductService } from '../product';
import {
  buildServiceIdentifyContext,
  cloneDataWithDepth,
  generateObjectId,
  generateSpacesText,
  getObservableValue,
  getSiteDepartmentCode,
  getStartOfLocalDayISOString,
  partitionAndSortItemsByChargeable,
  withBulkPrintPrompt,
} from '@app/shared/utils';
import {
  TOASTER_ERROR_MESSAGE,
  TOASTER_SUCCESS_MESSAGE,
} from '@shared/constants';
import {
  STAND_WORKSHEET_STATUS_ENUM_OPTIONS,
  STAND_WORKSHEET_STATUS_NAME,
  STAND_WORKSHEET_STATUS_OPTIONS_FOR_FILTER,
  STAND_WORKSHEET_STATUS_VALUE,
} from '@shared/types/enums/stand-worksheet-status.enum';
import {
  MAX_PAGE_SIZE,
  NESTED_PRODUCT_PAGE_SIZE,
  TIME_FORMATS,
  EVENT_SELECTOR_SELECT,
  CANCEL_ACTION,
} from '@config/global-constants';
import { SitesService } from '../sites';
import { AbstractControl, ValidationErrors } from '@angular/forms';
import { StandWorksheetPrintPdfService } from './stand-worksheet-print-pdf.service';
import {
  defaultWidgetData,
  gridSelectModalOptions,
} from '@components/xux/xux-edit-grid/xux-edit-grid-widget.settings';
import { BTN_CANCEL, BTN_DONE } from '@text-content/button-templates';
import {
  InventoryItemVenue as DMInventoryItemVenue,
  Metadata,
} from '@geniuspos/xenial-data-contracts/types/dm-entities';
import { PermissionService } from '@shared/services/session/permission.service';
import { STAND_WORKSHEET_PERMISSION_CODE } from '@shared/types/enums/stand-worksheet-permission-code.enum';
import {
  alphanumericComparator,
  DecimalNumber,
  decimalNumber,
} from '@app/shared/common';
import { getPureChangedItem } from '../really-change-detect';
import { mergeMap, takeUntil } from 'rxjs/operators';
import {
  IPdfData,
  PdfGenerateServiceV2,
  PdfSelectColumn,
} from '@app/shared/common/make-pdf/v2';
import { buildOpenSheetPdfConfig } from './stand-worksheet-opening-pdf-config';
import {
  CHARGEABLE_LABEL,
  STAND_WORKSHEET_PDF_SELECTED_COLUMNS,
} from './stand-worksheet.constants';
import {
  buildSWSPdfConfig,
  buildSinglePdfFileName,
} from './stand-worksheet-pdf-config';
import { DEPARTMENT_CODE_NOT_CONFIGURED } from '../transfer/transfer-constants';
import { InventoryItemVenue } from '@geniuspos/xenial-data-contracts/types/dm-entities/inventory-item-venue';
import { QohService } from '../qoh/qoh.service';
import { StandWorksheetCalcServiceProvider } from './calculation-services/stand-worksheet-calc-service-provider';
import { CALCULATION_VERSIONS } from './calculation-services/calculation.enums';
import { Router } from '@angular/router';
import { COLUMN_ALIGN_RIGHT } from '@shared/constants/column-align-definition';
import { getAuditTrailTemp } from './audit-trail-form-rules';
import { returnOperatorItem } from '@app/shared/utils/audit-trail-common-utils';
import { I18n } from '@app/i18n/strings-keys';
import { EventsService } from '../events';

const entityType: ENTITY_TYPES = ENTITY_TYPES.STAND_WORKSHEET;
const config: IEntityConfig = {
  ENTITY_TYPE: entityType,
  isMasterListAvailable: true,
  buttons: {},
  apiEndpoint: entityType,
  uiRoute: entityType,
  isFormServiceSupported: true,
  expandSidebar: false,
  showSidebarCollapsedBtn: true,
  auditTrailUrl: {
    information: 'stand-work-sheet',
    item: 'stand-work-sheet-item',
  },
  list: {
    columns: [],
    titleObs: new BehaviorSubject(null),
    documentQuery: {
      notNeedActive: true,
      orderby: 'site_name asc',
      select: ['site_id'],
    },
    gridOptions: {
      valueField: '_id',
    },
    async beforeFetchListData(
      entityService: StandWorksheetService,
    ): Promise<void> {
      const selectedEvent: IProcessedEvent = head(
        entityService.stateService.getByPath('events.selectedEvents'),
      );
      if (selectedEvent?.id) {
        const fetchAndSetCurrentEventStatus = async (): Promise<void> => {
          entityService.selectedEventStatus =
            await entityService.getCurrentEventStatus(selectedEvent?.id);
        };
        const getOpenStandWorksheetItemsPromise =
          entityService.getOpenStandWorksheetItems(selectedEvent.id);

        await Promise.all([
          fetchAndSetCurrentEventStatus(),
          getOpenStandWorksheetItemsPromise,
        ]);
      }
    },
  },
};

/**
 * Stand Worksheet service that extends BaseService to use
 * basic CRUD request operations
 */
@Injectable()
export class StandWorksheetService extends BaseService {
  public static config: IEntityConfig = config;
  public static ENTITY_TYPE: string = config.ENTITY_TYPE;

  @lazyInject(UiActions) public uiActions: UiActions;
  @lazyInject(XprtDataService) public xprtDataService: XprtDataService;
  @lazyInject(InventoryItemVenueService)
  public inventoryItemVenueService: InventoryItemVenueService;
  @lazyInject(RecipeVenueService) public recipeVenueService: RecipeVenueService;
  @lazyInject(ProductService) public productService: ProductService;
  @lazyInject(DmDataService) public dmDataService: DmDataService;
  @lazyInject(EventsActions) public eventsActions: EventsActions;
  @lazyInject(XprtDataActions) public xprtDataActions: XprtDataActions;
  @lazyInject(NgRedux) public ngRedux: NgRedux<IAppState>;
  @lazyInject(StandWorksheetPrintPdfService)
  public standWorksheetPrintPdfService: StandWorksheetPrintPdfService;
  @lazyInject(SitesService) public sitesService: SitesService;
  @lazyInject(PermissionService) public permissionService: PermissionService;
  @lazyInject(PdfGenerateServiceV2)
  public pdfGenerateServiceV2: PdfGenerateServiceV2;
  @lazyInject(QohService) public qohService: QohService;
  @lazyInject(StandWorksheetCalcServiceProvider)
  public standWorksheetCalcServiceProvider: StandWorksheetCalcServiceProvider;
  @lazyInject(Router) public router: Router;
  @lazyInject(EventsService) public eventsService: EventsService;

  @select(['ui', STAND_WORKSHEET_PDF_SELECTED_COLUMNS])
  public printColumns$: Observable<PdfSelectColumn[]>;
  @select(['events', 'selectedEvents']) public selectedEvents$: Observable<
    IProcessedEvent[]
  >;
  @select(['ui', 'formModalValue']) public formModalValue$: Observable<any>;
  @select(['tools', 'history']) public history$: Observable<any>;
  public eventList: IProcessedEvent[];
  public quickFilterFields: string[] = ['site_id', 'status'];
  public listProjection: string[] = ['site_id', 'status'];
  public modalId: string = '';
  public chargeable: boolean = true;
  // eslint-disable-next-line max-len
  public sitesSubTitle$: BehaviorSubject<string> = new BehaviorSubject<string>(
    this.i18nService.instant(I18n.Forms.GridMessages.ShowingEntities, {
      count: 0,
      entities: this.i18nService.instant(
        I18n.EntityNames.siteSingularAndPlural,
      ),
    }),
  );
  public sitesDisplayCount$: BehaviorSubject<number> =
    new BehaviorSubject<number>(0);

  public hasOpenStandWorksheetItems$: BehaviorSubject<boolean> =
    new BehaviorSubject(true);

  public xuxListContainer: XUXListContainerComponent;

  public iframeMode: boolean = this.stateService.getBySelector(
    STATE_SELECTORS.IFRAME_MODE,
  );

  public sites: SiteForTransfer[];
  public allCompanySites: SiteForTransfer[];
  public enableStandWorksheetAvailableSiteIds: ObjectId[] = [];
  public eventId: string = '';
  public auditTrailList: IAuditTrailData[] = [];
  public sWItemATNormalFields: string[] = [
    'manager_begin',
    'gratis',
    'ingredient_spoil',
    'end',
    'adjustment',
  ];
  public sWItemATClosureFields: string[] = [
    'gratis_post_closure',
    'ingredient_spoil_post_closure',
  ];
  public updatedFieldsMap: IStandWorkSheetItemUpdatedFieldsMap = {
    'stand-work-sheet-item': [
      ...this.sWItemATNormalFields,
      ...this.sWItemATClosureFields,
    ],
    'stand-work-sheet': ['cash_count'],
  };
  public excludedOperationMap: IStandWorkSheetItemUpdatedFieldsMap = {
    'stand-work-sheet-item': [EAUDIT_LOG_OPERATION.CREATE],
    'stand-work-sheet': [EAUDIT_LOG_OPERATION.CREATE],
  };

  public beforeStartListMethods: Function[] = [
    this.hookXuxListContainer,
    this.initSubscriptions,
    this.fetchDataForEventSelector,
    this.fetchCompanySites,
    this.getEventAndInitStandWorksheet,
  ];

  public beforeDestroyListMethods: Function[] = [this.cleanupSubscriptions];

  public disableCancelStandWorksheet: boolean = false;
  public selectedEventStatus: string;
  public get globalPriceSetting(): STAND_WORKSHEET_GLOBAL_PRICE_SETTING {
    return this.stateService.getStandWorkSheetGlobalPriceSetting();
  }

  public hookXuxListContainer(
    xuxListContainerComponent: XUXListContainerComponent,
  ): void {
    this.xuxListContainer = xuxListContainerComponent;
  }

  public getRecipes(): Observable<IApiListResponse<IBaseEntityType>> {
    return this.recipeVenueService.fetchList({
      filter: `chargeable_item_entity_id ne null and is_active eq true`,
      select: ['chargeable_item_entity_id', 'child_ingredients', 'products'],
    });
  }

  public initSubscriptions(): void {
    this.subscriptions.push(
      this.selectedEvents$
        .pipe(rx.distinctUntilChanged(isEqual))
        .subscribe((selectedEvents: IProcessedEvent[]): void => {
          const createButtonDefinition = this.config.buttons
            .create as ToolbarButtonDefinition;
          const cancelOpeningButtonDefinition = this.config.buttons
            .cancel_opening_stand_sheet as ToolbarButtonDefinition;
          const createButtonDisabled$ =
            createButtonDefinition.disabledObs as BehaviorSubject<boolean>;
          const cancelOpeningButtonDisabled$ =
            cancelOpeningButtonDefinition.disabledObs as BehaviorSubject<boolean>;
          if (!isEmpty(selectedEvents)) {
            const selectedEvent = first(selectedEvents);
            createButtonDisabled$.next(
              isEqual(selectedEvent.status, EVENT_STATUS_VALUE.Closed),
            );
            this.hasOpenStandWorksheetItems$.subscribe((hasOpenSheetItem) => {
              const disableCancelOpenStandWorksheetBtn =
                isEqual(selectedEvent.status, EVENT_STATUS_VALUE.Closed) ||
                !hasOpenSheetItem;
              cancelOpeningButtonDisabled$.next(
                disableCancelOpenStandWorksheetBtn,
              );
            });
            this.config.list.titleObs.next(
              `${selectedEvent.name} - ${selectedEvent.date}`,
            );
            this.config.list.documentQuery = {
              ...this.config.list.documentQuery,
              filter: `event_id eq objectid(${selectedEvent.id}) and is_active eq true`,
            };
            this.xuxListContainer.updateListViewData(
              merge({}, this.uiListParams, {
                currentPage: 1,
              }),
            );
            this.uiListParams = {};
            this.selectedEventStatus = head(selectedEvents).status;
          } else {
            createButtonDisabled$.next(true);
          }
        }),
    );
    this.subscriptions.push(
      this.formModalValue$.subscribe((value): void => {
        this.chargeable = get(get(value, this.modalId, {}), 'chargeable', true);
      }),
    );
    this.subscriptions.push(
      this.sitesDisplayCount$.subscribe((count: number): void => {
        const sitesSubTitle = this.i18nService.instant(
          I18n.Forms.GridMessages.ShowingEntities,
          {
            count,
            entities: this.i18nService.translate(
              I18n.EntityNames.siteSingularAndPlural,
            ),
          },
        );
        this.sitesSubTitle$.next(sitesSubTitle);
      }),
    );
    this.popupLandingEventSelectorSubs();
  }

  /**
   * get current selected event status through api
   * will return current status when
   *  1. call api error
   *  2. current status is closed
   *  3. curEventId is empty
   *
   * @param curEventId current selected event id
   */
  public async getCurrentEventStatus(curEventId: string): Promise<string> {
    // not select any event or event is closed, just return current status
    if (
      isEqual(this.selectedEventStatus, EVENT_STATUS_VALUE.Closed) ||
      isEmpty(curEventId)
    ) {
      return Promise.resolve(this.selectedEventStatus);
    }

    return this.xprtDataService
      .getEventsByFilter({
        filter: `_id eq in(${curEventId})`,
        include_inactive: true,
        select: ['status'],
      })
      .toPromise()
      .then((events) => get(head(events), 'status'))
      .catch(() => this.selectedEventStatus);
  }

  public getEventAndInitStandWorksheet(): void {
    this.subscriptions.push(
      this.history$
        .pipe(
          rx.mergeMap((history: string[]) => {
            const standWorksheetFlag = 'stand-worksheet?';
            if (
              history.length >= 2 &&
              includes(nth(history, 1), standWorksheetFlag)
            ) {
              const pageUri = last(split(nth(history, 1), standWorksheetFlag));
              const params = new URLSearchParams(pageUri);
              const eventId = params.get('eventId');
              const action = params.get('action');
              if (eventId && isEqual(action, 'close')) {
                return this.xprtDataService.getEventDetailById(eventId);
              }
            }

            return of();
          }),
        )
        .subscribe((selectedEvent) => {
          const processEventsList = this.xprtDataService.processEventsList([
            selectedEvent as IEvent,
          ]);
          const type: FilterOptionType = 'containsAny';
          this.uiListParams = {
            filterModel: {
              status: {
                type,
                filter: [STAND_WORKSHEET_STATUS_VALUE.Open],
                headerText: STAND_WORKSHEET_STATUS_NAME.Open,
              },
            },
          };
          this.eventsActions.saveSelectedEvents(processEventsList);
        }),
    );
  }

  public fetchDataForEventSelector(): void {
    const state: IAppState = this.ngRedux.getState();
    if (!isEmpty(state.events.list)) return;
    this.eventsActions.fetchEventsList({});
  }

  public popupLandingEventSelectorSubs(): void {
    const unsubscribe$: Subject<void> = new Subject<void>();
    observableCombineLatest([
      this.xprtDataService.fetchCompleteEventsList({}).pipe(
        rx.filter((data) => !isEmpty(data)),
        rx.first(),
        rx.tap((eventList: IProcessedEvent[]): void => {
          this.eventList = eventList;
        }),
      ),
      this.selectedEvents$,
      this.history$,
    ])
      .pipe(takeUntil(unsubscribe$))
      .subscribe(
        ([_, selectedEvents, history]: [
          IProcessedEvent[],
          IProcessedEvent[],
          string[],
        ]): void => {
          const standWorksheetFlag = 'stand-worksheet?';
          let eventId = null;
          if (
            history.length >= 2 &&
            includes(nth(history, 1), standWorksheetFlag)
          ) {
            const pageUri = last(split(nth(history, 1), standWorksheetFlag));
            eventId = includes(pageUri, 'eventId');
          }
          if (
            isNil(head(selectedEvents)) &&
            isNil(eventId) &&
            isEqual(this.router.url, '/stand-worksheet')
          ) {
            this.selectEventBtnClickHandler();
          }
          unsubscribe$.next();
        },
      );
  }

  public fetchCompanySites(): void {
    this.sitesService
      .fetchList({
        filter: `is_active eq true`,
        select: ['name', 'id', 'type', 'store_number', 'metadata'],
      })
      .subscribe((siteResponse: ISiteResponse) => {
        this.allCompanySites = siteResponse.items as SiteForTransfer[];
      });
  }

  public cleanupSubscriptions(): void {
    this.enableStandWorksheetAvailableSiteIds = [];
    forEach(this.subscriptions, (subscription) => subscription.unsubscribe());
  }

  public async openEventSelectorModal(): Promise<IModalDialogResult> {
    const state: IAppState = this.ngRedux.getState();
    const selectedEventIds = state.events.selectedEventIds;
    const modalOptions = standWorkSheetModalDefinition.eventSelectorModal(
      selectedEventIds,
      ['open', 'closed'],
      this.eventList,
    );
    const dialogResult = await this.uiActions.promptFormModal(modalOptions);

    return {
      confirmed: dialogResult.confirmed,
      modalResult: dialogResult.modalResult,
      value: dialogResult.value,
    };
  }

  public async openPrintEventSelectorModal(): Promise<IModalDialogResult> {
    const modalOptions = standWorkSheetModalDefinition.printOpenSheetsModal({
      eventList: this.eventList,
      validator: this.getSiteValidator(),
      i18nService: this.i18nService,
    });

    this.modalId = generateObjectId();
    const dialogResult = await this.uiActions.promptFormModal(
      merge(modalOptions, { modalId: this.modalId }),
    );
    this.eventId = '';

    return {
      confirmed: dialogResult.confirmed,
      modalResult: dialogResult.modalResult,
      value: dialogResult.value,
    };
  }

  public async openReInitializeModal(
    selectedEvent: IProcessedEvent,
  ): Promise<IModalDialogResult> {
    this.uiActions.enableLoader();
    const sitesForStandWorkSheets: ISitesForStandWorkSheet[] =
      await observableCombineLatest([
        this.fetchList({
          filter: `event_id eq objectid(${selectedEvent.id}) and is_active eq true`,
          select: ['site_id', 'store_number'],
        }),
        this.xprtDataService.getEventDetailById(selectedEvent.id, {
          available_sites_select: 'name,store_number,metadata,i18n',
        }),
      ])
        .pipe(
          rx.map(([standWorksheetList, eventDetail]) => {
            return xorWith(
              standWorksheetList.items,
              eventDetail.available_sites,
              (a, b) => a.id === b.site_id,
            );
          }),
          rx.switchMap((notGenerateStandSheetSites) => {
            const siteIds: string[] = map(notGenerateStandSheetSites, 'id');

            return observableCombineLatest([
              observableOf(notGenerateStandSheetSites),
              this.dmDataService.getSiteGroupId(siteIds),
            ]);
          }),
          rx.switchMap(([notGenerateStandSheetSites, siteGroupId]) => {
            return observableCombineLatest([
              observableOf(notGenerateStandSheetSites),
              this.dmDataService.getSitesPreferencesBySiteGroupId(siteGroupId),
            ]);
          }),
          rx.map(([notGenerateStandSheetSites, sitesPreferences]) => {
            const [enableStandWorksheetSites, disableStandWorksheetSites] =
              chain(notGenerateStandSheetSites)
                .map((site) => {
                  const enableStandWorksheet = get(
                    find(
                      sitesPreferences,
                      (preferences) => preferences.site_id === site.id,
                    ),
                    [
                      'preferences',
                      'back_office',
                      'inventory',
                      'enable_standworksheet',
                    ],
                    false,
                  );

                  return {
                    ...site,
                    enableStandWorksheet,
                  };
                })
                .sortBy((site) => toLower(site?.name))
                .partition('enableStandWorksheet')
                .value();

            return concat(
              enableStandWorksheetSites,
              disableStandWorksheetSites,
            ) as ISitesForStandWorkSheet[];
          }),
          rx.catchError(() => {
            return observableOf([]);
          }),
        )
        .toPromise();
    this.uiActions.disableLoader();

    const entityIdsForMetadatas: EntityId[] = chain(sitesForStandWorkSheets)
      .flatMap('metadata')
      .map('entity_id')
      .value();

    const subRecipeSettings: IModalDialogOptions = {
      title: I18n.Common.SiteSelector,
      subTitleObs: this.sitesSubTitle$,
      modalClass: `modal-lg hidden-header-checkbox`,
      buttons: [
        {
          ...BTN_DONE,
          caption: I18n.Common.ReInitialize,
          disabled: (value): boolean => isEmpty(value.items),
        },
        BTN_CANCEL,
      ],
      schema: {
        properties: {
          items: {
            minItems: null,
          },
        },
      },
      formRules: {
        fields: {
          items: {
            title: null,
            ignoreAutoTitleWhenTranslate: true,
            widgetData: {
              displayCountObs: this.sitesDisplayCount$,
              valueField: 'id',
              userGridOptions: {
                overlayNoRowsTemplate: this.i18nService.instant(
                  I18n.Common.NoRowsToShow,
                ),
                isRowSelectable({ data }): boolean {
                  return data.enableStandWorksheet;
                },
                getRowClass({ data }): string {
                  return !data.enableStandWorksheet ? 'row-disabled' : '';
                },
              },
              columns: [
                {
                  title: I18n.Sites.SiteId,
                  path: 'store_number',
                  defaultView: true,
                  headerComponentParams: {
                    hintOptions: {
                      description: this.i18nService.instant(
                        I18n.Forms.StandWorksheetFormTips
                          .StandWorksheetReinitializedTooltipMessage,
                      ),
                    },
                  },
                  sortable: true,
                  filterParams: {
                    quickFilter: true,
                  },
                  comparator: (valueA, valueB): number =>
                    alphanumericComparator(valueA, valueB),
                },
                {
                  title: I18n.Sites.SiteName,
                  path: 'name',
                  defaultView: true,
                  sortable: true,
                  filterParams: {
                    quickFilter: true,
                  },
                  comparator: (valueA, valueB): number =>
                    alphanumericComparator(valueA, valueB),
                },
                {
                  title: I18n.EntityNames.Tags,
                  path: 'metadata',
                  defaultView: true,
                  sortable: true,
                  filterType: CELL_FILTER.entity,
                  filterParams: {
                    quickFilter: true,
                    entity: ENTITY_TYPES.TAG,
                    entitySelector: (item: ISiteTag): boolean =>
                      includes(entityIdsForMetadatas, item.entity_id),
                    default: {
                      type: 'containsAny',
                    },
                    filterOptions: ['containsAny'],
                    filterItemSourceQuery: {
                      filter: `metadata_type eq 'tag'`,
                      select: ['entity_id', 'name', '_id'],
                    },
                    filterValueGetter: (data): EntityId[] =>
                      flatten(map(data.metadata, 'entity_id')),
                  },
                  valueGetter: (params: ValueGetterParams): string => {
                    const metadata: Metadata[] = get(
                      params,
                      'data.metadata',
                      [],
                    );

                    return chain(metadata)
                      .filter({ metadata_type: 'tag' })
                      .map('name')
                      .join(', ')
                      .value();
                  },
                },
              ],
            },
          },
        },
      },
    };

    const modalOptions: IModalDialogOptions = merge(
      {},
      gridSelectModalOptions(sitesForStandWorkSheets, this.i18nService),
      defaultWidgetData,
      subRecipeSettings,
    );
    const dialogResult = await this.uiActions.promptFormModal(modalOptions);

    return {
      confirmed: dialogResult.confirmed,
      modalResult: dialogResult.modalResult,
      value: dialogResult.value,
    };
  }

  public selectEventBtnClickHandler = async (): Promise<void> => {
    let result: IProcessedEvent[] | IModalDialogResult;
    if (this.iframeMode) {
      const state: IAppState = this.ngRedux.getState();
      const storedEvent = map(state.events.selectedEvents, 'id');

      let filteredEventIds: string[];
      if (!isEmpty(storedEvent)) {
        try {
          this.uiActions.enableLoader();
          filteredEventIds = await this.xprtDataService
            .getEventIdsByFilter({
              status: [EVENT_STATUS_VALUE.Open, EVENT_STATUS_VALUE.Closed],
              ids: storedEvent,
            })
            .toPromise();
          this.uiActions.disableLoader();
        } catch (error) {
          this.uiActions.disableLoader();
        }
      }
      result = await this.xprtDataActions.showEventSelector({
        selectionLimit: 1,
        defaultSelectedEvents: filteredEventIds || [],
        select: EVENT_SELECTOR_SELECT,
        gridExtraFilters: [`status eq in(open,closed)`],
        defaultSort: 'status desc,event_days/start_date_time desc',
      });
      if (isEqual(result.modalResult, CANCEL_ACTION)) {
        return;
      }
      const processEventsList = this.xprtDataService.processEventsList(
        result.items,
      );
      this.eventsActions.saveSelectedEvents(processEventsList);

      return;
    }
    result = await this.openEventSelectorModal();
    if (!result.confirmed) return;
    this.eventsActions.saveSelectedEventsById(result.value.events);

    return;
  };

  public getSiteValidator(): (
    control: AbstractControl,
  ) => Observable<ValidationErrors | null> {
    return (control: AbstractControl): Observable<ValidationErrors | null> => {
      const eventId = control.value;
      if (isEmpty(eventId) || (!!this.eventId && this.eventId === eventId)) {
        return observableOf([]);
      }
      if (eventId) {
        this.uiActions.enableModalLoader();
      }
      this.eventId = eventId;

      return this.xprtDataService.getEventDetailById(eventId).pipe(
        rx.map((eventDetail) => {
          return map(get(eventDetail, 'available_sites', []), 'id');
        }),
        rx.switchMap((availableSiteIds) => {
          const eventSiteIdsIsEmpty = isEmpty(availableSiteIds);
          if (eventSiteIdsIsEmpty) {
            return observableOf({
              error: this.i18nService.instant(
                I18n.ErrorMessages.NoActiveSiteError,
              ),
            });
          }

          return this.dmDataService.getSiteGroupId(availableSiteIds).pipe(
            rx.switchMap((siteGroupId) =>
              this.dmDataService.getSitesPreferencesBySiteGroupId(siteGroupId),
            ),
            rx.map((data) => {
              const enableStandWorksheetSites = filter(
                data,
                'preferences.back_office.inventory.enable_standworksheet',
              );
              this.enableStandWorksheetAvailableSiteIds = map(
                enableStandWorksheetSites,
                'site_id',
              );
              const enableStandWorksheetSitesIsEmpty = isEmpty(
                enableStandWorksheetSites,
              );
              if (enableStandWorksheetSitesIsEmpty) {
                return {
                  error: this.i18nService.instant(
                    I18n.InfoMessages.NoEnableStandWorksheet,
                  ),
                };
              }

              return null;
            }),
          );
        }),
        rx.catchError((errors) => {
          this.uiActions.disableModalLoader();

          return observableThrowError(get(errors, 'errors'));
        }),
        rx.finalize(() => {
          this.uiActions.disableModalLoader();
        }),
      );
    };
  }

  public printOpeningSheetsBtnClickHandler = async (): Promise<void> => {
    const result = await this.openPrintEventSelectorModal();

    if (!result.confirmed) return;
    this.uiActions.enableLoader();
    this.uiActions.preventLoaderCloseWhenTimeout(true);
    try {
      const events = await this.getEventList();

      const selectedEvent = first(
        filter(events, (item) => first(result.value.event_ids) === item.id),
      );
      if (isEqual(selectedEvent.status, EVENT_STATUS_VALUE.Open)) {
        const standWorkSheetSiteIds = await this.fetchList({
          filter: `(event_id eq objectid(${selectedEvent.id}) and is_active eq true)`,
          select: [
            'site_id',
            'store_number',
            'status',
            'internalColumnSelector',
            'updated_at',
          ],
          orderby: 'store_number asc',
          top: MAX_PAGE_SIZE,
        })
          .pipe(
            rx.map((standWorkSheetResponse) =>
              map(standWorkSheetResponse.items, 'site_id'),
            ),
          )
          .toPromise();
        if (isEmpty(standWorkSheetSiteIds)) {
          this.uiActions.showToasterMessage({
            type: NotificationType.ERROR,
            title: TOASTER_ERROR_MESSAGE.title,
            body: this.i18nService.instant(
              I18n.InfoMessages.NoActiveStandWorksheetError,
            ),
          });
          this.uiActions.disableLoader();

          return;
        }
        await this.orgPdfData(
          selectedEvent,
          standWorkSheetSiteIds,
          result.value.chargeable,
        );

        return;
      }

      // pending event PDF Data
      await this.orgPdfData(
        selectedEvent,
        this.enableStandWorksheetAvailableSiteIds,
        result.value.chargeable,
      );
    } catch (e) {
      this.uiActions.showToasterMessage({
        type: NotificationType.ERROR,
        title: TOASTER_ERROR_MESSAGE.title,
        body: this.i18nService.instant(I18n.InfoMessages.LoadingFailedError),
      });
      this.uiActions.disableLoader();
    }
  };

  public async getEventList(): Promise<IProcessedEvent[]> {
    return (await this.eventsService
      .fetchList({
        select: split(EVENT_SELECTOR_SELECT),
      })
      .pipe(
        rx.first(),
        rx.map((res) => get(res, 'items')),
      )
      .toPromise()) as IProcessedEvent[];
  }

  public sortSitesData(siteIds: ObjectId[]): Record<string, any>[] {
    // sort the sites by name
    const siteData = map(siteIds, (siteId) => {
      const site = first(
        filter(this.allCompanySites, (siteValue) =>
          isEqual(siteValue.id, siteId),
        ),
      );

      return {
        ...site,
        fullSiteName: generateSpacesText(site?.name, site?.store_number),
      };
    });

    return sortBy(siteData, (item) => lowerCase(item.name));
  }

  public hasDmDepartmentConfigSite(site: ISite): boolean {
    const departmentCode = toLower(getSiteDepartmentCode(site));

    return (
      !isEqual(departmentCode, toLower(DEPARTMENT_CODE_NOT_CONFIGURED)) &&
      this.stateService.getStandWorkSheetDepartmentCodeSetting(departmentCode)
    );
  }

  public getQuantityOnHandData(
    inventoryItems: IBaseEntityType[],
    sites: ISite[],
  ): Observable<IQuantityOnHandResponse> {
    const defaultReturn = {
      current_page: 1,
      items: [],
      page_count: 0,
      page_size: 0,
      total: 0,
    };
    // use the site department code and DM config to filter site and get Qoh
    const hasDepartCodeAndDmSettingSites = filter(sites, (site) =>
      this.hasDmDepartmentConfigSite(site),
    );

    // get Site Qoh
    const qohRequestData: IQuantityOnHandItem[] = [];
    forEach(hasDepartCodeAndDmSettingSites, (site) => {
      const inventoryItemsForSite = filter(inventoryItems, (item) =>
        isEqual(item.site_id, site.id),
      );
      if (!isEmpty(inventoryItemsForSite)) {
        qohRequestData.push({
          site_id: site.id,
          inventory_item_entity_ids: map(inventoryItemsForSite, 'entity_id'),
        });
      }
    });
    if (isEmpty(qohRequestData)) {
      return of(defaultReturn);
    }

    return this.qohService.batchFetchQuantityOnHand(qohRequestData);
  }

  public async orgPdfData(
    selectedEvent: IProcessedEvent,
    siteIds: ObjectId[],
    chargeable: boolean,
  ): Promise<void> {
    const sortedSiteData = this.sortSitesData(siteIds);
    try {
      const siteGroupIds = await this.dmDataService
        .getSiteGroupIdList(siteIds)
        .toPromise();
      const allCompaniesSiteGroupId = await this.dmDataService
        .getSiteGroupId(map(this.allCompanySites, 'id'))
        .toPromise();
      const productMap = await this.productService
        .fetchList(this.getProductQuery(), {
          headers: {
            [EHeaderName.XSiteGroupId]: allCompaniesSiteGroupId,
          },
          fetchFullListData: true,
        })
        .pipe(
          rx.map((products: IApiListResponse) => {
            return reduce(
              products.items,
              (mapRes, product: IProduct) => {
                return {
                  ...mapRes,
                  [product.entity_id]: {
                    ...product,
                  },
                };
              },
              {},
            );
          }),
        )
        .toPromise();
      const isOpen = isEqual(selectedEvent.status, EVENT_STATUS_VALUE.Open);
      let xviInventoryItems = [];
      if (isOpen) {
        xviInventoryItems = await this.getStandSheetItemList(
          {
            filter: `event_id eq in(${selectedEvent.id}) and is_active eq true and site_id eq in({siteGroup})`,
            select: ['begin', 'inventory_item_entity_id', 'site_id'],
          },
          {
            headers: {
              [EHeaderName.XSiteGroupId]: allCompaniesSiteGroupId,
            },
          },
        ).toPromise();
      }

      const openingSheetsData = await this.inventoryItemVenueService
        .batchFetchCurrentList(siteGroupIds, {
          filter: `show_on_stand_worksheet eq true and is_master eq false`,
          select: [
            'name',
            'show_on_stand_worksheet',
            'parent_product_entity_id',
            'site_id',
            'is_chargeable',
          ],
          masterFilter: 'show_on_stand_worksheet eq true',
        })
        .pipe(
          rx.mergeMap(({ items: dmInventoryItems }: IBaseEntityResponse) => {
            return this.getQuantityOnHandData(
              dmInventoryItems as InventoryItemVenue[],
              sortedSiteData as ISite[],
            ).pipe(
              rx.map((qohRes) => {
                return { items: dmInventoryItems, qohRes: qohRes.items };
              }),
            );
          }),
          rx.map((dmInventoryItemsAndQohResult) => {
            if (isOpen) {
              return this.generateOpenStatusOpeningSheetsData(
                sortedSiteData,
                dmInventoryItemsAndQohResult.items,
                xviInventoryItems,
                dmInventoryItemsAndQohResult.qohRes,
                productMap,
                chargeable,
              );
            }

            return this.generatePendingStatusOpeningSheetsData(
              sortedSiteData,
              dmInventoryItemsAndQohResult.items,
              dmInventoryItemsAndQohResult.qohRes,
              productMap,
              chargeable,
            );
          }),
        )
        .toPromise();

      const pdfConfig = buildOpenSheetPdfConfig(
        (_, id) => {
          const sheetItem = find(openingSheetsData, { id });

          return {
            items: sheetItem.standSheetList,
            event_name: selectedEvent.name,
            event_start_date: this.companyService.convertUTCDateWithTimeZone(
              selectedEvent.event_days[0]?.start_date_time,
              true,
              TIME_FORMATS.L_LT,
            ),
            event_end_date: this.companyService.convertUTCDateWithTimeZone(
              selectedEvent.event_days[0]?.end_date_time,
              true,
              TIME_FORMATS.L_LT,
            ),
            chargeable: chargeable
              ? CHARGEABLE_LABEL.chargeable
              : CHARGEABLE_LABEL.allItems,
            site: sheetItem.fullSiteName,
          };
        },
        {
          data: map(openingSheetsData, 'id'),
        },
        this.i18nService,
      );

      await this.pdfGenerateServiceV2.printPdfAsync(pdfConfig);
    } catch (e) {
      this.uiActions.showToasterMessage({
        type: NotificationType.ERROR,
        title: TOASTER_ERROR_MESSAGE.title,
        body: this.i18nService.instant(I18n.InfoMessages.LoadingFailedError),
      });
      this.uiActions.disableLoader();
    }
  }

  public createBtnClickHandler = async (): Promise<void> => {
    const state: IAppState = this.ngRedux.getState();
    const selectedEvent: IProcessedEvent = first(state.events.selectedEvents);
    if (isNil(selectedEvent)) return;
    const result = await this.openReInitializeModal(selectedEvent);
    if (!result.confirmed) return;
    try {
      this.uiActions.enableLoader();
      await this.reInitializeStandWorksheet(
        selectedEvent.id,
        map(result.value.items, 'id'),
      );
      this.uiActions.showToasterMessage({
        type: NotificationType.SUCCESS,
        title: TOASTER_SUCCESS_MESSAGE.title,
        body: this.i18nService.instant(I18n.InfoMessages.Didsuccessfully, {
          did: this.i18nService.instant(I18n.Common.ReInitialized),
        }),
      });
      this.xuxListContainer.refresh();
    } catch (e) {
      this.uiActions.showToasterMessage({
        type: NotificationType.ERROR,
        title: TOASTER_ERROR_MESSAGE.title,
        body: this.i18nService.instant(I18n.InfoMessages.FailedToOperation, {
          operation: this.i18nService.instant(I18n.Common.reinitialize),
        }),
      });
    } finally {
      this.uiActions.disableLoader();
    }
  };

  public reInitializeStandWorksheet(
    eventId: string,
    siteIds: string[],
  ): Promise<IBaseEntityType> {
    return this.http
      .post(StandWorksheetService.ENTITY_TYPE, {
        event_id: eventId,
        site_ids: siteIds,
      })
      .pipe(this.catchHttpError())
      .toPromise();
  }

  public constructor(public injector: Injector) {
    super(injector);
    this.config.buttons = {
      create: {
        click: this.createBtnClickHandler,
        disabledObs: new BehaviorSubject(false),
      },
      select_event: { click: this.selectEventBtnClickHandler },
      print_opening_sheets: { click: this.printOpeningSheetsBtnClickHandler },
      remove: false,
      cancel_opening_stand_sheet: {
        click: this.cancelOpenStandSheetBtnClickHandler.bind(this),
        disabledObs: new BehaviorSubject(false),
      },
      edit: {
        hidden: true,
      },
      bulk_print: {
        caption: I18n.Common.Print,
        hidden: this.bulkPrintExportHidden.bind(this),
        click: this.bulkPrintExport(false),
      },
      bulk_export: {
        caption: I18n.Common.ExportPDF,
        hidden: this.bulkPrintExportHidden.bind(this),
        click: this.bulkPrintExport(true),
      },
    };
    this.config.list.documentOperationOptions = {
      continueFetchCondition: (): boolean => {
        const state: IAppState = this.ngRedux.getState();

        return !isEmpty(state.events.selectedEvents);
      },
    };
    this.config.list.columns.push(
      {
        path: 'store_number',
        title: I18n.Sites.SiteId,
        filterType: CELL_FILTER.string,
        filterParams: {
          quickFilter: true,
        },
        sortable: true,
        cellRenderer: CELL_RENDERER.entity_link_renderer,
        comparator: (valueA, valueB): number =>
          alphanumericComparator(valueA, valueB),
        defaultView: true,
      },
      {
        title: I18n.Sites.SiteName,
        labelPath: 'site_name',
        sortUseLabelPath: true,
        path: 'site_id',
        defaultView: true,
        sortable: true,
        filterType: CELL_FILTER.entity,
        filterParams: {
          quickFilter: true,
          default: {
            type: 'containsAny' as FilterOptionType,
          },
          suppressSelectAllControl: true,
          filterItemsSource: FilterItemsSourceEnum.XPRT_SITES,
          filterOptions: ['containsAny'] as FilterOptionType[],
          filterItemSourceQuery: {
            select: ['name', 'id'],
          },
          suppressUIFiltering: true,
        },
      },
      {
        path: 'status',
        title: I18n.Common.Status,
        filterType: CELL_FILTER.enum,
        filterParams: {
          values: STAND_WORKSHEET_STATUS_OPTIONS_FOR_FILTER,
        },
        sortable: true,
        defaultView: true,
        cellRenderer: (record: ICellRendererParams): string =>
          this.i18nService.instant(
            STAND_WORKSHEET_STATUS_ENUM_OPTIONS[record.value],
          ),
      },
      {
        path: 'diff_physical_terminal',
        title: I18n.Forms.StandWorksheetForm.PhysTerminalSalesDiff,
        sortable: true,
        defaultView: true,
        cellRenderer: CELL_RENDERER.entity_link_renderer,
        valueGetter: ({ data, colDef: { field } }: ValueGetterParams): string =>
          this.physicalTerminalDiffFormat(data?.[field]),
        ...COLUMN_ALIGN_RIGHT,
      },
      {
        path: 'diff_percent_physical_terminal',
        title: I18n.Forms.StandWorksheetForm.PhysTerminalSalesDiffPercent,
        sortable: true,
        defaultView: true,
        cellRenderer: CELL_RENDERER.entity_link_renderer,
        valueGetter: ({ data, colDef: { field } }: ValueGetterParams): string =>
          this.physicalTerminalDiffPercentFormat(data?.[field]),
        ...COLUMN_ALIGN_RIGHT,
      },
      {
        path: COLUMN_SELECTOR_ID,
        width: 50,
        title: '',
        defaultView: true,
        cellRenderer: CELL_RENDERER.stand_worksheet_actions_renderer,
        cellRendererParams: {},
        pinned: detectMobile() ? false : 'right',
        lockPinned: true,
      },
    );
  }

  protected bulkPrintExportHidden(selectedItems: IBaseEntityType[]): boolean {
    if (selectedItems.length < 1) {
      return true;
    }
  }

  protected bulkPrintExport(isExport: boolean): Function {
    return withBulkPrintPrompt(
      async (selectedItems: IBaseEntityType[]): Promise<void> => {
        const entryFormHeaders =
          this.standWorksheetPrintPdfService.getPDFHeadersByPermission();
        const isOffPostClosureSetting =
          !this.stateService.getStandWorksheetPostClosureSetting();

        let allRecipesData: IApiListResponse<IBaseEntityType>;
        let allProductsData: Record<string, IProductMap>;
        let allEventsData: IEvent[];
        let allSitesData: (ISite | SiteForTransfer)[];
        let allInventoryItems;

        const state: IAppState = this.ngRedux.getState();
        const eventId = get(head(state.events.selectedEvents), 'id');
        const pdfConfig = buildSWSPdfConfig(
          async (_, bulkData) => {
            const isCurrentSitePrice = isEqual(
              this.globalPriceSetting,
              STAND_WORKSHEET_GLOBAL_PRICE_SETTING.CURRENT_SITE_PRICE,
            );

            if (isCurrentSitePrice) {
              forEach(allProductsData, (product: IProductMap) => {
                product.parent_product_price = get(
                  product.pricesMap,
                  get(bulkData, 'site_id'),
                  product.parent_product_price,
                );
              });
            }

            return this.getPdfData(bulkData, {
              allRecipesData,
              allProductsData: cloneDataWithDepth(allProductsData),
              allEventsData,
              allSitesData,
              allInventoryItems,
            });
          },
          {
            entryFormHeaders,
            isOffPostClosureSetting,
            uiActions: this.uiActions,
            pdfSelectColumn: getObservableValue(this.printColumns$),
            i18nService: this.i18nService,
          },
          false,
          {
            data: async (): Promise<IPdfData[]> => {
              const allBulkPrintData = await this.getBulkPrintData(
                selectedItems,
                eventId,
              );

              allRecipesData =
                allBulkPrintData?.bulkPrintOptionsData?.allRecipesData;
              allProductsData =
                allBulkPrintData?.bulkPrintOptionsData?.allProductsData;
              allEventsData =
                allBulkPrintData?.bulkPrintOptionsData?.allEventsData;
              allSitesData =
                allBulkPrintData?.bulkPrintOptionsData?.allSitesData;
              allInventoryItems =
                allBulkPrintData?.bulkPrintOptionsData?.allInventoryItems;

              return allBulkPrintData?.data;
            },
            exportFileName: (pdfDataList): string => {
              const firstPdfData = head(pdfDataList);

              if (isEqual(selectedItems.length, 1)) {
                return `${buildSinglePdfFileName(firstPdfData)}.pdf`;
              }

              return `Stand Worksheet - ${firstPdfData?.originEventname}`;
            },
            batchCount: 5,
            sortFiledPath: 'siteName',
          },
        );

        if (isExport) {
          await this.pdfGenerateServiceV2.downloadPdfAsync(pdfConfig);

          return;
        }

        await this.pdfGenerateServiceV2.printPdfAsync(pdfConfig);
      },
      {
        isExport,
        uiActions: this.uiActions,
        i18nService: this.i18nService,
      },
    );
  }

  public async getBulkPrintData(
    selectedItems,
    eventId,
  ): Promise<IAllBulkPrintData> {
    const siteIds: string[] = map(selectedItems, 'site_id');
    const siteGroupIds: string[] = await this.dmDataService
      .getSiteGroupIdList(siteIds)
      .toPromise();
    const allInventoryItems = await this.inventoryItemVenueService
      .batchFetchCurrentList(siteGroupIds, {
        select: [
          'name',
          'show_on_stand_worksheet',
          'parent_product_entity_id',
          'code',
          'site_id',
          'is_chargeable',
        ],
        filter: `show_on_stand_worksheet eq true and is_master eq false`,
        masterFilter: 'show_on_stand_worksheet eq true',
      })
      .toPromise();

    let allRecipesData;
    let allProductsData;

    if (isEmpty(allInventoryItems.items)) {
      allRecipesData = {
        items: [],
      } as IBaseEntityResponse;
      allProductsData = {};
    } else {
      allRecipesData = await this.getRecipes().pipe(rx.first()).toPromise();
      allProductsData = await this.fetchProductData(null, siteIds, true)
        .pipe(rx.first())
        .toPromise();
    }
    const allEventsData = await this.xprtDataService
      .getEventsByFilter({
        filter: `_id eq in(${eventId})`,
        select: ['id', 'name', 'event_days'],
        include_inactive: true,
      })
      .toPromise();
    const allSitesData = await this.sitesService
      .fetchList({
        select: ['name', 'id', 'store_number'],
        filter: `_id eq in(${siteIds.join(',')})`,
        include_inactive: true,
      })
      .pipe(
        rx.first(),
        rx.map((sitesRes) => sitesRes?.items),
      )
      .toPromise();

    return {
      data: sortBy(selectedItems, (item) => toLower(item?.site_name)),
      bulkPrintOptionsData: {
        allRecipesData,
        allProductsData,
        allEventsData,
        allSitesData,
        allInventoryItems,
      },
    };
  }

  public frontToBackItemMapper(doc: IStandSheet): IBaseEntityType {
    delete doc.event_id;

    return flow<
      IStandSheet[],
      IStandSheet,
      IStandSheet,
      IStandSheet,
      IStandSheet
    >(
      this.processReallyChangedItems.bind(this),
      this.processInformationData.bind(this),
      this.processInventoryItemsData.bind(this),
      super.frontToBackItemMapper.bind(this),
    )(doc);
  }

  /**
   * override doc items field only use doc.virtual.changed_items
   * will pass this logic if doc not have virtual.change_items
   * will delete doc.items if virtual.changed_items is empty or changed items is empty
   *
   * @param doc save doc
   */
  public processReallyChangedItems(doc: IStandSheet): IStandSheet {
    if (!has(doc, 'virtual.changed_items')) {
      return doc;
    }

    const changedItems: ChangedStandSheetItems = get(
      doc,
      'virtual.changed_items',
      {},
    );

    // not have any item or changed item, delete items field and return
    if (isEmpty(changedItems)) {
      unset(doc, 'items');

      return doc;
    }

    const reallyChangedItems = chain(changedItems)
      .map((item) => {
        if (!isEmpty(getPureChangedItem(item))) {
          return { ...item };
        }

        return null;
      })
      .compact()
      .value();

    // nothing changed, delete items field and return
    if (isEmpty(reallyChangedItems)) {
      unset(doc, 'items');

      return doc;
    }

    doc.items = reallyChangedItems;

    return doc;
  }

  public processInformationData(doc: IStandSheet): IStandSheet {
    const state: IAppState = this.stateService.getState();
    // not need this request attribute in stand worksheet list page.
    if (!isEqual(state.router, '/stand-worksheet')) {
      doc.cash_count = new DecimalNumber(
        !isNil(doc?.cash_count) ? doc.cash_count?.toString() : 0,
      );
    }

    return doc;
  }

  public processInventoryItemsData(doc: IStandSheet): IStandSheet {
    if (!has(doc, 'items')) return doc;
    const adjustmentPermissionValue: boolean = this.hasAdjustmentPermission();
    const preparedList: IStandWorkSheetItemToEnd[] = map(
      doc.items,
      (item: IStandWorkSheetItemFullData) => {
        const useZeroAsNilValueFields = ['gratis', 'ingredient_spoil'];

        let newItem = reduce(
          ['manager_begin', 'gratis', 'ingredient_spoil', 'end'],
          (changedItem, key) => {
            const value = get(item, key);

            // it's means this key is not changed
            if (isUndefined(value)) {
              return changedItem;
            }

            changedItem[key] = isNil(value)
              ? value
              : decimalNumber(value?.toString()).valueOf();

            if (
              isNil(changedItem[key]) &&
              includes(useZeroAsNilValueFields, key)
            ) {
              changedItem[key] = 0;
            }

            return changedItem;
          },
          {},
        );

        if (item.needInsert) {
          newItem = merge({}, newItem, {
            inventory_item_entity_id: get(item, 'entity_id'),
            is_chargeable: item.chargeable,
          });
        } else {
          newItem = merge({}, newItem, { id: get(item, '_id') });
        }

        if (adjustmentPermissionValue && !isUndefined(item.adjustment)) {
          newItem['adjustment'] = new DecimalNumber(
            !isNil(item?.adjustment) ? item.adjustment?.toString() : 0,
          );
        }

        return newItem;
      },
    ) as IStandWorkSheetItemToEnd[];

    return { ...doc, items: preparedList };
  }

  public getStandSheetItemList(
    query?: IFilterQuery,
    options: IDocumentOperationOptions = {},
  ): Observable<IStandWorkSheetItem[]> {
    const params: HttpParams = this.createParams({
      ...query,
      top: 10000,
    });
    const headers = this.composeHeadersForUpdateRequest({
      ...options,
    });

    return this.http
      .get<IApiListResponse>(`/stand-worksheet-item/`, {
        params,
        headers,
        context: buildServiceIdentifyContext(ENTITY_TYPES.STAND_WORKSHEET_ITEM),
      })
      .pipe(
        this.catchHttpError(options.errorOverride),
        rx.map((response) => {
          if (Array.isArray(response.items)) {
            return response;
          }
          throw new Error(response.errorMessage);
        }),
        rx.map((response: IApiListResponse<IStandWorkSheetItem>) =>
          get(response, 'items', []),
        ),
      );
  }

  /**
   * @param siteId
   * @param standWorkSheetItems Too many item may cause an exception to the request
   * @param xviInventoryItems
   */
  public fetchInventoryItemAndRecipeData(
    siteId: string,
    standWorkSheetItems: DMInventoryItemVenue[] | IStandWorkSheetItem[],
    xviInventoryItems: IStandWorkSheetItem[] = [],
  ): Observable<IStandWorkSheetItemFullData[]> {
    return this.combineAllRelatedData(
      standWorkSheetItems,
      siteId,
      xviInventoryItems,
    );
  }

  /**
   * @param standWorkSheetItems Too many item may cause an exception to the request
   * @param siteId
   * @param ids Too many item may cause an exception to the request
   * @param xviInventoryItems
   */
  public combineAllRelatedData(
    standWorkSheetItems: DMInventoryItemVenue[] | IStandWorkSheetItem[],
    siteId: string,
    xviInventoryItems: IStandWorkSheetItem[],
  ): Observable<IStandWorkSheetItemFullData[]> {
    const productIds: string[] = uniq(
      compact(
        map<DMInventoryItemVenue | IStandWorkSheetItem, string>(
          standWorkSheetItems,
          (item) => item?.parent_product_entity_id,
        ),
      ),
    );

    return forkJoin([
      of(xviInventoryItems),
      of(standWorkSheetItems),
      this.getRecipes(),
      this.fetchProductData(productIds, siteId),
    ]).pipe(
      rx.map((allRelatedResponse: IStandSheetCombineData) => {
        return this.processStandSheetItemListData(allRelatedResponse);
      }),
    );
  }

  public getProductQuery(productIds?: ObjectId[]): IFilterQuery {
    let queryFilter = `product_type eq in(${[
      EPRODUCT_TYPES.STANDARD,
      EPRODUCT_TYPES.RETAIL_ITEM,
      EPRODUCT_TYPES.MODIFIER,
    ].join(',')})`;
    if (!isEmpty(productIds)) {
      queryFilter += ` and entity_id eq in(${productIds.join()})`;
    }

    return {
      filter: queryFilter,
      select: [
        'prices.unit_price',
        'name',
        'product_id',
        'prices.type',
        'prices.site_id',
      ],
      include_entities: [ENTITY_TYPES.PRODUCT, ENTITY_TYPES.PRODUCT_PRICE],
      expand: `product-price($filter=is_active eq nin(false) and type eq '${EBasePriceTypes.STANDARD}')`,
      effectiveDate: getStartOfLocalDayISOString(),
      include_mappings: false,
      include_nested_type: ['master', 'current'],
      top: NESTED_PRODUCT_PAGE_SIZE,
    };
  }

  public fetchProductData(
    productIds: ObjectId[],
    siteId: ObjectId | ObjectId[],
    prepareProductMap: boolean = false,
  ): Observable<Record<string, IProductMap>> {
    return this.dmDataService
      .getSiteGroupId(map(this.allCompanySites, 'id'))
      .pipe(
        mergeMap((groupId: string) =>
          this.productService
            .fetchList(this.getProductQuery(productIds), {
              headers: {
                [EHeaderName.XSiteGroupId]: groupId,
              },
              fetchFullListData: true,
            })
            .pipe(
              rx.map((products: IApiListResponse) => {
                const productMap = reduce(
                  products.items,
                  (mapRes, product: IProduct) => {
                    let sitePrice: IProductPrice = maxBy(
                      product.prices,
                      'unit_price',
                    );
                    const maxPrice = cloneDataWithDepth(sitePrice);
                    const isCurrentSitePrice = isEqual(
                      this.globalPriceSetting,
                      STAND_WORKSHEET_GLOBAL_PRICE_SETTING.CURRENT_SITE_PRICE,
                    );
                    if (isCurrentSitePrice) {
                      const currentPrice = find(
                        product.prices,
                        (price) => price.site_id === (siteId as string),
                      );
                      if (!isNil(currentPrice)) {
                        sitePrice = currentPrice;
                      }
                    }
                    const productItem = {
                      parent_product_name: product.name,
                      parent_product_price: get(sitePrice, 'unit_price'),
                      parent_product_id: product.product_id,
                    };
                    if (prepareProductMap && isCurrentSitePrice) {
                      const pricesMap = {};
                      forEach(siteId as string[], (siteEntityId) => {
                        const currentPrice = find(
                          product.prices,
                          (price) => price.site_id === (siteEntityId as string),
                        );
                        if (!isNil(currentPrice)) {
                          sitePrice = currentPrice;
                        } else {
                          sitePrice = maxPrice;
                        }
                        set(
                          pricesMap,
                          siteEntityId,
                          get(sitePrice, 'unit_price'),
                        );
                      });
                      set(productItem, 'pricesMap', pricesMap);
                    }

                    return {
                      ...mapRes,
                      [product.entity_id]: productItem,
                    };
                  },
                  {},
                );

                return productMap;
              }),
            ),
        ),
      );
  }

  public processStandSheetItemListData(
    allRelatedResponse: IStandSheetCombineData,
  ): IStandWorkSheetItemFullData[] {
    const [
      standSheetResponse,
      inventoryItemResponse,
      recipeVenueResponse,
      productResponse,
    ] = allRelatedResponse;

    const processStandSheetData = map(
      inventoryItemResponse,
      (item: IStandSheet): IStandSheet => {
        let inventoryItemTarget: IStandSheet = null;
        forEach(standSheetResponse, (standSheetItem) => {
          if (standSheetItem.inventory_item_entity_id === item.entity_id) {
            inventoryItemTarget = merge({}, standSheetItem, omit(item, '_id'));
          }
        });

        if (!inventoryItemTarget) {
          inventoryItemTarget = item;
          inventoryItemTarget.needInsert = true;
        }

        const recipeChargeableData: IRecipeVenue[] = filter(
          recipeVenueResponse.items,
          (recipeItem) =>
            recipeItem.chargeable_item_entity_id === item.entity_id,
        );

        const recipeTarget: IRecipeVenue = find(
          recipeChargeableData,
          (recipeItem) =>
            !isNil(
              find(recipeItem?.products, {
                entity_id: inventoryItemTarget?.parent_product_entity_id,
              }),
            ),
        );

        let baseMeasureCount = null;
        if (recipeTarget) {
          baseMeasureCount = this.calcBaseMeasureCount(recipeTarget);
        }

        const productTarget =
          productResponse[inventoryItemTarget?.parent_product_entity_id];

        if (inventoryItemTarget?.show_on_stand_worksheet) {
          return {
            ...inventoryItemTarget,
            chargeable: inventoryItemTarget.is_chargeable,
            parent_product_name: productTarget
              ? get(productTarget, 'parent_product_name', '')
              : null,
            parent_product_price: get(
              productTarget,
              'parent_product_price',
              null,
            ),
            parent_product_id: get(productTarget, 'parent_product_id', null),
            recipe_measure_factor: baseMeasureCount || null,
          } as IStandSheet;
        }
      },
    );

    return filter(
      processStandSheetData,
      Boolean,
    ) as IStandWorkSheetItemFullData[];
  }

  public calcBaseMeasureCount(recipeTarget: IRecipeVenue): DecimalNumber {
    const measureFactor = filter(
      recipeTarget.child_ingredients,
      (recipeItem) =>
        recipeTarget.chargeable_item_entity_id ===
        recipeItem.inventory_item_entity_id,
    );

    const count = measureFactor
      ? reduce(
          measureFactor,
          (sum: DecimalNumber, item) => sum.add(item.base_measure_count),
          new DecimalNumber(0),
        )
      : new DecimalNumber(0);

    return count;
  }

  public processSnapshotStandSheetItemListData(
    snapshotList: Partial<IStandWorkSheetItem[]>,
    version: CALCULATION_VERSIONS,
  ): IStandWorkSheetItemFullData[] {
    const calculationService =
      this.standWorksheetCalcServiceProvider.getService(version);

    return map(snapshotList, (item) => {
      return {
        ...(item.status === STAND_WORKSHEET_STATUS_VALUE.Completed
          ? calculationService.processSnapshotSWItem(
              item as IStandWorkSheetItemFullData,
            )
          : item),
        chargeable: item.is_chargeable,
        name: item.inventory_item_name,
        parent_product_name: item.product_name,
        parent_product_price: item.product_price,
        parent_product_id: item.product_id,
        code: item.inventory_item_code,
      } as IStandWorkSheetItemFullData;
    });
  }

  public async cancelOpenStandSheetBtnClickHandler(): Promise<void> {
    const confirmResult = await this.uiActions.confirm({
      text: this.i18nService.instant(
        I18n.ConfirmMessages.ConfirmCancelAllOpenStandWorksheets,
      ),
    });
    if (!confirmResult.confirmed) return;
    this.uiActions.enableLoader();
    this.uiActions.preventLoaderCloseWhenTimeout(true);
    try {
      const state: IAppState = this.stateService.getState();
      const selectedEvent: IProcessedEvent = first(state.events.selectedEvents);
      const { successCount = 0, totalCount = null } = await this.fetchList({
        filter: `event_id eq objectid(${selectedEvent.id}) and status eq 'open' and is_active eq true`,
        select: ['site_id', 'store_number'],
      })
        .pipe(
          rx.switchMap(({ items: standSheetItems = [] }) => {
            if (isEmpty(standSheetItems)) {
              this.uiActions.showToasterMessage({
                type: NotificationType.ERROR,
                title: TOASTER_ERROR_MESSAGE.title,
                body: this.i18nService.instant(
                  I18n.InfoMessages.NoStandWorksheetCanBeCanceled,
                ),
              });
            }

            return this.bulkUpdateEntity(
              map(standSheetItems, (standSheetItem) => ({
                status: STAND_WORKSHEET_STATUS_VALUE.Canceled,
                _id: standSheetItem._id,
              })),
              {
                suppressErrors: true,
              },
              1,
            );
          }),
        )
        .toPromise();
      const cancelAllSuccess =
        isEqual(totalCount, successCount) && totalCount && successCount;
      const failedCount = totalCount - successCount;
      this.xuxListContainer.refresh();
      this.uiActions.disableLoader();
      if (cancelAllSuccess) {
        this.uiActions.showToasterMessage({
          type: NotificationType.SUCCESS,
          title: TOASTER_SUCCESS_MESSAGE.title,
          body: this.i18nService.instant(
            I18n.InfoMessages.CanceledAllOpenStandWorksheets,
          ),
        });
      } else if (failedCount) {
        this.uiActions.showToasterMessage({
          type: NotificationType.ERROR,
          title: TOASTER_ERROR_MESSAGE.title,
          body: this.i18nService.instant(
            I18n.InfoMessages.CanceledStandWorksheetFailed,
            {
              failedCount,
            },
          ),
        });
      }
      this.uiActions.preventLoaderCloseWhenTimeout(false);
    } catch (error) {
      this.uiActions.disableLoader();
      this.uiActions.preventLoaderCloseWhenTimeout(false);
      this.uiActions.showToasterMessage({
        type: NotificationType.ERROR,
        title: error?.title || TOASTER_ERROR_MESSAGE.title,
        body:
          error?.meta?.message ||
          this.i18nService.instant(I18n.ErrorMessages.CheckInternetAndTryAgain),
      });
    }
  }

  public hasBeginCountPermission(): boolean {
    return this.permissionService.canOperateByCode(
      ENTITY_TYPES.STAND_WORKSHEET,
      STAND_WORKSHEET_PERMISSION_CODE.BeginningCount,
    );
  }

  public hasAdjustmentPermission(): boolean {
    return this.permissionService.canOperateByCode(
      ENTITY_TYPES.STAND_WORKSHEET,
      STAND_WORKSHEET_PERMISSION_CODE.Adjustment,
    );
  }

  public hasExpectedQTYPermission(): boolean {
    return this.permissionService.canOperateByCode(
      ENTITY_TYPES.STAND_WORKSHEET,
      STAND_WORKSHEET_PERMISSION_CODE.ExpectedQty,
    );
  }

  public async getOpenStandWorksheetItems(selectedEventId): Promise<void> {
    try {
      const openStandWorksheets = await this.fetchList({
        filter: `event_id eq objectid(${selectedEventId}) and status eq 'open' and is_active eq true`,
        top: 1,
      }).toPromise();
      if (isEmpty(openStandWorksheets.items)) {
        this.hasOpenStandWorksheetItems$.next(false);
      } else {
        this.hasOpenStandWorksheetItems$.next(true);
      }
    } catch (error) {
      this.uiActions.showToasterMessage({
        type: NotificationType.ERROR,
        title: error.title || TOASTER_ERROR_MESSAGE.title,
        body:
          error.meta?.message ||
          this.i18nService.instant(I18n.ErrorMessages.CheckInternetAndTryAgain),
      });
    }
  }

  public calculatePercentage(originValue: number, value: number): number {
    let calculateNumber: number;
    if (
      isNil(value) ||
      isNil(originValue) ||
      Number(value) === 0 ||
      Number(originValue) === 0
    ) {
      calculateNumber = 0;
    } else {
      calculateNumber = new DecimalNumber(originValue).div(value).valueOf();
    }

    return calculateNumber;
  }

  public showDiffNumberAndPercentage(
    item: IInformationData | object,
    diffField: string,
    originField: string,
  ): string {
    const diffNumber: string = this.numberFormatService.getNumberFormatter(
      true,
    )({ value: item[diffField] });

    const percentageNumber: number = this.calculatePercentage(
      item[diffField],
      item[originField],
    );

    const percentageNumberFormatter: string =
      this.numberFormatService.percentageNumberFormat(percentageNumber);

    return `${diffNumber}(${percentageNumberFormatter})`;
  }

  /**
   * Upload physical terminal difference
   * This method ignores errors outside the permission
   *
   * @param standWorksheetDoc
   * @param informationData Information data or object
   * @returns Promise
   */
  public async savePhysTerminalDiffData(
    standWorksheetDoc: IBaseEntityType,
    informationData: IInformationData,
  ): Promise<void> {
    if (isEmpty(standWorksheetDoc?._id)) return;

    const diffInDB = pick(standWorksheetDoc, [
      '_id',
      'diff_physical_terminal',
      'diff_percent_physical_terminal',
    ]);

    const physTerminalDiff = informationData?.phys_terminal_diff ?? 0;
    const physicalSales = informationData?.physical_sales ?? 0;

    const diff = {
      _id: standWorksheetDoc?._id,
      diff_physical_terminal: physTerminalDiff,
      diff_percent_physical_terminal: this.calculatePercentage(
        <number>physTerminalDiff,
        <number>physicalSales,
      ),
    };

    if (isEqual(diff, diffInDB)) return;

    await this.bulkUpdatePhysTerminalDiff([diff])
      .toPromise()
      .catch((err) => err);
  }

  public getSWSWithSnapObs(
    standWorksheetDoc: IBaseEntityType,
    standWorksheetItems: IStandWorkSheetItem[],
  ): Observable<IBaseEntityType> {
    return observableOf(
      this.processSnapshotStandSheetItemListData(
        standWorksheetItems,
        standWorksheetDoc?.formula_version,
      ),
    ).pipe(
      rx.map((swsItems) => ({
        ...pick(standWorksheetDoc, [
          'event_id',
          'event_name',
          'event_start_date_time',
          'event_end_date_time',
        ]),
        ...pick(standWorksheetDoc, ['site_id', 'site_name', 'store_number']),
        items: swsItems,
      })),
    );
  }

  public getSWSWithDmInventoryObs(
    standWorksheetDoc: IBaseEntityType,
    standWorksheetItems: IStandWorkSheetItem[],
    bulkPrintData?: IBulkPrintData,
  ): Observable<IBaseEntityType> {
    return observableCombineLatest([
      this.mergeSWItemsWithDmObs(
        standWorksheetDoc,
        standWorksheetItems,
        bulkPrintData,
      ),
      iif(
        () => isNil(bulkPrintData?.allEventsData),
        this.xprtDataService
          .getEventDetailById(standWorksheetDoc?.event_id, {
            select: ['id', 'name', 'event_days'],
          })
          .pipe(rx.map((events) => [events] as IEvent[])),
        of(bulkPrintData?.allEventsData),
      ),
      iif(
        () => isNil(bulkPrintData?.allSitesData),
        this.sitesService
          .fetchList({
            filter: `_id eq in(${standWorksheetDoc?.site_id})`,
            select: ['name', 'id', 'store_number'],
            include_inactive: true,
          })
          .pipe(rx.map((sitesRes) => sitesRes?.items)),
        of(bulkPrintData?.allSitesData),
      ),
    ]).pipe(
      rx.map(([swsItems, eventsData, sitesData]) => {
        const curEvent: IEvent = find(eventsData, {
          id: standWorksheetDoc?.event_id,
        });
        const curSite: ISite | SiteForTransfer = find(sitesData, {
          id: standWorksheetDoc?.site_id,
        });

        return {
          event_id: curEvent?.id,
          event_name: curEvent?.name,
          event_start_date_time: get(curEvent, 'event_days[0].start_date_time'),
          event_end_date_time: get(curEvent, 'event_days[0].end_date_time'),
          ...pick(curSite, ['store_number']),
          site_name: curSite?.name,
          site_id: curSite?.id,
          items: swsItems,
        };
      }),
    );
  }

  public mergeSWItemsWithDmObs(
    standWorksheetDoc: IBaseEntityType,
    standWorksheetItems: IStandWorkSheetItem[],
    bulkPrintData?: IBulkPrintData,
  ): Observable<IStandWorkSheetItemFullData[]> {
    return iif(
      () => isNil(bulkPrintData?.allInventoryItems),
      this.inventoryItemVenueService.fetchCurrentList(
        {
          select: [
            'name',
            'show_on_stand_worksheet',
            'parent_product_entity_id',
            'code',
            'site_id',
            'is_chargeable',
          ],
        },
        [standWorksheetDoc?.site_id],
      ),
      of(bulkPrintData?.allInventoryItems),
    ).pipe(
      rx.map((inventoryItemList) => {
        return filter(
          inventoryItemList.items,
          (item) => item.site_id === standWorksheetDoc.site_id,
        );
      }),

      rx.switchMap((dmInventoryItems) => {
        if (isEmpty(dmInventoryItems)) {
          return of([]);
        }

        if (
          isNil(bulkPrintData?.allRecipesData) ||
          isNil(bulkPrintData?.allProductsData)
        ) {
          return this.combineAllRelatedData(
            dmInventoryItems,
            standWorksheetDoc.site_id,
            standWorksheetItems,
          );
        }

        return of(
          this.processStandSheetItemListData([
            standWorksheetItems,
            dmInventoryItems,
            bulkPrintData?.allRecipesData,
            bulkPrintData?.allProductsData,
          ]),
        );
      }),
    );
  }

  public async getPdfData(
    standWorksheet: IBaseEntityType,
    bulkPrintData?: IBulkPrintData,
  ): Promise<IBaseEntityType> {
    const standWorksheetDoc: IBaseEntityType =
      await this.apiActions.fetchGetDocumentById(
        StandWorksheetService.ENTITY_TYPE,
        standWorksheet._id,
        {
          noLoader: true,
          query: {
            get_updated_items: false,
          },
          suppressErrors: true,
        },
      );

    if (has(standWorksheetDoc, 'errors')) {
      return Promise.reject(
        this.i18nService.instant(I18n.ErrorMessages.CheckInternetAndTryAgain),
      );
    }

    const isUseSnapshot = includes(
      [
        STAND_WORKSHEET_STATUS_VALUE.Approved,
        STAND_WORKSHEET_STATUS_VALUE.Completed,
        STAND_WORKSHEET_STATUS_VALUE.Canceled,
      ],
      get(standWorksheetDoc, 'status'),
    );

    const calculationService =
      this.standWorksheetCalcServiceProvider.getService(
        standWorksheetDoc?.formula_version,
      );

    const pdfData$ = this.getStandSheetItemList({
      filter: `stand_work_sheet_entity_id eq objectid(${standWorksheetDoc.entity_id})${
        isUseSnapshot ? ' and is_active eq true' : ''
      }`,
      select: ['*'],
    }).pipe(
      rx.switchMap((standWorksheetItems) =>
        iif(
          () => isUseSnapshot,
          this.getSWSWithSnapObs(standWorksheetDoc, standWorksheetItems),
          this.getSWSWithDmInventoryObs(
            standWorksheetDoc,
            standWorksheetItems,
            bulkPrintData,
          ),
        ),
      ),
      rx.map((swsDoc) => {
        const calcSwsItems = map(
          flatten(swsDoc.items),
          (item: IStandWorkSheetItemFullData) =>
            calculationService.calculationData(item, isUseSnapshot),
        );
        const informationData = calculationService.calcStandWorksheetSum(
          standWorksheetDoc,
          calcSwsItems,
        );
        this.savePhysTerminalDiffData(standWorksheetDoc, informationData);

        set(swsDoc, 'items', partitionAndSortItemsByChargeable(calcSwsItems));
        set(swsDoc, 'virtual.information_list', informationData);
        set(swsDoc, 'viewSettingModalValue.chargeable', false);
        set(swsDoc, 'status', standWorksheetDoc?.status);

        return swsDoc;
      }),
    );

    const pdfData = await pdfData$.pipe(rx.first()).toPromise();

    return this.standWorksheetPrintPdfService.getPdfData(pdfData, null);
  }

  public physicalTerminalDiffFormat(value: number): string {
    if (isNil(value)) return '';

    return this.numberFormatService.getNumberFormatter(true)({ value });
  }

  public physicalTerminalDiffPercentFormat(value: number): string {
    if (isNil(value)) return '';

    return this.numberFormatService
      .percentageNumberFormat(value)
      .replace(/\+/, '');
  }

  /**
   * Bulk update physical terminal difference
   *
   * @param standWorkSheets Array of objects containing
   * the _id, physical terminal difference, and physical terminal difference percentage
   */
  public bulkUpdatePhysTerminalDiff(
    standWorkSheets: {
      _id: string;
      diff_physical_terminal: DecimalNumber | number;
      diff_percent_physical_terminal: number;
    }[],
  ): Observable<any> {
    return this.http
      .patch(
        `/${this.config.apiEndpoint}/bulk-update-phy-diff`,
        standWorkSheets,
      )
      .pipe(this.catchHttpError());
  }

  /**
   * return two type template form-rules for audit trail
   * information // item
   */

  public getAuditTrailTemp(
    data: IStandWorkSheetItemItemViewAuditLog[],
    options: {
      type: 'item' | 'information';
      loader$: BehaviorSubject<boolean>;
      user$: BehaviorSubject<IEntityFilterItem[]>;
    },
  ): IAuditTrailFormRule {
    return getAuditTrailTemp(this, data, options);
  }

  public auditTrailFormateNumber(params: ValueFormatterParams): string {
    const startEnd = get(params, 'value');

    return this.formateNumberForStartEnd(startEnd);
  }

  public applyAuditLogsWithPopulatedLogs(
    populatedLogs: IAuditLog[],
    endpointName = '',
  ): IStandWorkSheetItemItemViewAuditLog[] | IStandWorkSheetItemViewAuditLog[] {
    const result = [];
    const sortedLogs = chain(populatedLogs)
      .flatten()
      .orderBy('date', 'desc')
      .value();

    sortedLogs.forEach((doc: IAuditLog) => {
      const date = doc.date;
      const operation = find(
        this.operateList,
        (item) => item.operator_id === doc.info.person_id,
      );
      let record:
        | IStandWorkSheetItemItemViewAuditLog
        | IStandWorkSheetItemViewAuditLog;

      if (endpointName === 'stand-work-sheet-item') {
        record = {
          date,
          operator: returnOperatorItem(operation, doc, this.i18nService),
          ...this.returnISWItemViewAudit(doc),
        } as IStandWorkSheetItemItemViewAuditLog;
      } else if (endpointName === 'stand-work-sheet') {
        record = {
          date,
          operator: returnOperatorItem(operation, doc, this.i18nService),
          previous: get(
            doc,
            'info.previousFields.cash_count.$numberDecimal',
            null,
          ),
          changed: get(
            doc,
            'info.updatedFields.cash_count.$numberDecimal',
            null,
          ),
        } as IStandWorkSheetItemViewAuditLog;
      }
      if (
        endpointName === 'stand-work-sheet-item' &&
        !this.stateService.getStandWorksheetPostClosureSetting()
      ) {
        const sWItemATField: string[] = [
          'manager_begin',
          'gratis',
          'spoilage',
          'end',
          'adjustment',
        ];
        if (
          !every(sWItemATField, (field) => {
            const startEnd = get(record, field);

            return isNil(get(startEnd, 'start')) && isNil(get(startEnd, 'end'));
          })
        ) {
          result.push(record);
        }
      } else {
        result.push(record);
      }
    });

    return result;
  }

  public returnISWItemViewAudit(doc: IAuditLog): ISWItemViewAudit {
    const itemViewAudit = {};
    forEach(
      get(this.updatedFieldsMap, 'stand-work-sheet-item'),
      (field: string) => {
        let newField: string = field;
        if (field === 'ingredient_spoil') {
          newField = 'spoilage';
        }
        set(itemViewAudit, newField, this.generateStartAndEndValue(doc, field));
      },
    );

    return itemViewAudit as ISWItemViewAudit;
  }

  public generateStartAndEndValue(
    doc: IAuditLog,
    field: string,
  ): IAuditLogItem {
    let startValue = get(doc, `info.previousFields.${field}`, null);
    if (!isNull(startValue) && get(startValue, '$numberDecimal')) {
      startValue = startValue.$numberDecimal.toString();
    }
    let endValue = get(doc, `info.updatedFields.${field}`, null);
    if (!isNull(endValue) && get(endValue, '$numberDecimal')) {
      endValue = endValue.$numberDecimal.toString();
    }

    return {
      start: startValue,
      end: endValue,
    };
  }

  // eslint-disable-next-line max-params
  private generateOpenStatusOpeningSheetsData(
    sites: Record<string, any>[],
    dmInventoryItems: IBaseEntityType[],
    xviInventoryItems: IStandWorkSheetItem[],
    qohRes: IQohInventoryItemVenue[],
    productMap: {},
    chargeable: boolean,
  ): Record<string, any>[] {
    return map(sites, (site) => {
      const inventoryItemForSite = filter(
        dmInventoryItems,
        (item) =>
          isEqual(item.site_id, site.id) && item.show_on_stand_worksheet,
      );
      const processStandSheetData = map(
        inventoryItemForSite,
        (item: IStandSheet): IStandSheet => {
          const productTarget = productMap[item?.parent_product_entity_id];

          return {
            ...item,
            chargeable: item.is_chargeable,
            begin: this.hasDmDepartmentConfigSite(site as ISite)
              ? this.getOpenBeginValue(
                  xviInventoryItems,
                  qohRes,
                  site.id,
                  item.entity_id,
                )
              : null,
            parent_product_name: productTarget
              ? get(productTarget, 'parent_product_name', '')
              : null,
            parent_product_price: productTarget
              ? this.getProductPrice(productTarget, site.id)
              : null,
            parent_product_id: get(productTarget, 'parent_product_id', null),
          } as IStandSheet;
        },
      );

      const standSheetItems = chargeable
        ? filter(processStandSheetData, (item) => item.chargeable)
        : processStandSheetData;

      return {
        ...site,
        standSheetList: partitionAndSortItemsByChargeable(
          standSheetItems as IStandSheet[],
        ),
      };
    });
  }

  private getOpenBeginValue(
    xviInventoryItems: IStandWorkSheetItem[],
    qohRes: IQohInventoryItemVenue[],
    siteId: string,
    entityId: string,
  ): DecimalNumber {
    const xviInventoryItem = find(
      xviInventoryItems,
      (item: IStandWorkSheetItem) =>
        isEqual(item.site_id, siteId) &&
        isEqual(item.inventory_item_entity_id, entityId),
    );
    if (isNil(xviInventoryItem)) {
      // use current site inventory qoh
      return new DecimalNumber(
        find(
          qohRes,
          (item) =>
            isEqual(item.site_id, siteId) &&
            isEqual(item.inventory_item_entity_id, entityId),
        )?.count ?? 0,
      );
    }

    return xviInventoryItem.begin ?? null;
  }

  private getBeginValue(
    site: ISite,
    qohRes: IQohInventoryItemVenue[],
    entityId: string,
  ): number {
    return (
      find(
        qohRes,
        (item) =>
          isEqual(item.site_id, site.id) &&
          isEqual(item.inventory_item_entity_id, entityId),
      )?.count ?? 0
    );
  }

  // eslint-disable-next-line max-params
  private generatePendingStatusOpeningSheetsData(
    sites: Record<string, any>[],
    dmInventoryItems: IBaseEntityType[],
    qohRes: IQohInventoryItemVenue[],
    productMap: {},
    chargeable: boolean,
  ): Record<string, any>[] {
    return map(sites, (site) => {
      const inventoryItemForSite = filter(dmInventoryItems, (item) =>
        isEqual(item.site_id, site.id),
      );
      let inventoryItemList = [];
      const siteResult = { ...site };

      forEach(inventoryItemForSite, (inventoryItem) => {
        inventoryItem.chargeable = inventoryItem.is_chargeable;
        const productTarget =
          productMap[inventoryItem?.parent_product_entity_id];
        inventoryItemList.push({
          ...inventoryItem,
          begin: this.hasDmDepartmentConfigSite(site as ISite)
            ? this.getBeginValue(site as ISite, qohRes, inventoryItem.entity_id)
            : null,
          parent_product_price: productTarget
            ? this.getProductPrice(productTarget, site.id)
            : null,
        });
      });

      if (chargeable) {
        inventoryItemList = filter(inventoryItemList, 'chargeable');
      }
      siteResult.standSheetList = partitionAndSortItemsByChargeable(
        filter(inventoryItemList),
      );

      return siteResult;
    });
  }

  private getProductPrice(product: IProduct, siteId: ObjectId): IProductPrice {
    let sitePrice: IProductPrice = maxBy(product.prices, 'unit_price');
    if (
      isEqual(
        this.globalPriceSetting,
        STAND_WORKSHEET_GLOBAL_PRICE_SETTING.CURRENT_SITE_PRICE,
      )
    ) {
      const currentPrice = find(
        product.prices,
        (price) => price.site_id === siteId,
      );
      if (!isNil(currentPrice)) {
        sitePrice = currentPrice;
      }
    }

    return get(sitePrice, 'unit_price', null);
  }

  // eslint-disable-next-line max-lines
}
